// @flow

import { cardTokenizer } from '@ebanx/ebanx-js';
import { type OutgoingPaymentTokenizedCard, type TokenizeArgs } from './tokenized';
import { getHolderName } from './get-holder-name';
import { getNumber } from './get-number';
import { getSecurityCode } from './get-security-code';
import { getExpiryDate } from './get-expiry-date';
import { PlaceOrderError } from '../outgoing-payment';

export async function tokenize({ card, publicIntegrationKey, country, paymentTypeCode }: TokenizeArgs): Promise<OutgoingPaymentTokenizedCard> {
  try {
    return await cardTokenizer.tokenize({
      card: {
        holderName: getHolderName(card),
        number: getNumber(card),
        cvv: getSecurityCode(card),
        dueDate: getExpiryDate(card),
      },
      countryCode: country,
      paymentTypeCode,
    });
  } catch (error) {
    const result = error.message.match(/BP-DR-\d+/);
    const code = result && result[0];

    throw new PlaceOrderError({
      code: ((code === 'BP-DR-83' || code === 'BP-R-32') ? code : 'CI-000'),
      message: 'Card tokenization error',
    });
  }
}
